import * as yup from "yup";

import * as RHFBonusCardValidationRules from "@/utils/validation/schemas/bonusCard.RHF";

export const OptionalBonusCardFieldSchema = yup.object({
    bonusCardNumber: RHFBonusCardValidationRules.optionalBonusCard
});

export const RequiredBonusCardFieldSchema = yup.object({
    bonusCardNumber: RHFBonusCardValidationRules.bonusCard
});

type OptionalBonusCardFormValues = yup.InferType<
    typeof OptionalBonusCardFieldSchema
>;

type RequiredBonusCardFormValues = yup.InferType<
    typeof RequiredBonusCardFieldSchema
>;

export type BonusCardFieldValues =
    | OptionalBonusCardFormValues
    | RequiredBonusCardFormValues;
